jQuery(document).ready(function($) {
	const pastProjectsSliders = document.querySelectorAll('.past-projects .splide');
    if (pastProjectsSliders.length === 0) return;

    function addPastProjectsSplideArrows(splideInstance) {
        const prevArrow = splideInstance.root.querySelector('.splide__arrow--prev');
        const nextArrow = splideInstance.root.querySelector('.splide__arrow--next');
        
        if (prevArrow) {
          prevArrow.innerHTML = `<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="49" height="49" transform="matrix(-1 0 0 1 49 0)" fill="white"/> <path d="M23.2928 14.7073L25.1602 16.5747L18.5578 23.1771L35.1771 23.1771L35.1771 25.818L18.5578 25.818L25.1602 32.4204L23.2928 34.2879L13.5024 24.4976L23.2928 14.7073Z" fill="#0E3773"/> </svg>`;
        }
        
        if (nextArrow) {
          nextArrow.innerHTML = `<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="49" height="49" fill="white"/> <path d="M25.7072 14.7073L23.8398 16.5747L30.4422 23.1771L13.8229 23.1771L13.8229 25.818L30.4422 25.818L23.8398 32.4204L25.7072 34.2879L35.4976 24.4976L25.7072 14.7073Z" fill="#0E3773"/> </svg>`;
        }
    }

    pastProjectsSliders.forEach(slider => {
        if (typeof Splide !== 'undefined') {
            const pastProjectsSplide = new Splide(slider, {
                type: 'loop',
                focus: 'center',
                perPage: 1,
                perMove: 1,
                arrows: true,
                pagination: false,
                trimSpace: false,
                gap: '30px',
                // padding: '25%',
                // height: '520px',
                breakpoints: {
                    1536: { gap: '24px' },
                    992:  { gap: '20px' },
                    768:  { gap: '20px' },
                    640:  { gap: '15px' },
                },
            }).mount();
            addPastProjectsSplideArrows(pastProjectsSplide);
        }
    });
});